import {Component} from '@angular/core';
import {CartLine} from "@app/core/cart/domain/dtos/cart-line";
import {CartDetailViewModel} from "@app/presentation/pages/cart-detail/cart-detail.view-model";
import {DisplayService} from "@app/presentation/services/display.service";
import {firstValueFrom, Observable} from "rxjs";
import {map} from "rxjs/operators";
import {PopupDispatcher} from "@app/presentation/components/errors/popup.dispatcher";
import {ShareProductsModalService} from "@app/presentation/pages/share-products/share-products-modal.service";

@Component({
  selector: 'app-cart-detail',
  templateUrl: './cart-detail.component.html',
  styleUrls: ['./cart-detail.component.scss'],
  providers: [CartDetailViewModel]
})
export class CartDetailComponent {

  cartDetail$ = this.cartDetailViewModel.cartDetail$;

  cartLines$: Observable<CartLine[]> = this.cartDetail$.pipe(
      map(cartDetail => cartDetail.lines),
  );

  isCartEmpty$ = this.cartLines$.pipe(
      map(cartLines => cartLines.length < 1),
  );

  cartQuantity$: Observable<number> = this.cartDetailViewModel.cartQuantity$;

  isMobile$ = this.displayService.isMobileDisplay$;

  similarProducts$ = this.cartDetailViewModel.similarProducts$;

  isLoggedIn$ = this.cartDetailViewModel.isLoggedIn$;

  promotions$ = this.cartDetailViewModel.promotions$;

  canShareProducts$ = this.isCartEmpty$.pipe(map(isCartEmpty => !isCartEmpty));

  constructor(
    private cartDetailViewModel: CartDetailViewModel,
    private displayService: DisplayService,
    private popupDispatcher: PopupDispatcher,
    private shareProductsModalService: ShareProductsModalService,
  ) {
    this.popupDispatcher.setNotifier(this.cartDetailViewModel.notifier);
  }

  cartLineTrackBy(index: number,cartLine: CartLine) {
    return cartLine.code + cartLine.promotionCode
  }

  async onClickShareAllProducts() {
    const cartLines = await firstValueFrom(this.cartLines$);
    this.shareProductsModalService.shareCartLines(cartLines);
  }

}
